import type { Tab } from '#/components/Tabs/Tab';
import { useTabsController } from '#/components/Tabs/useTabsController';

import {
  TabsHorizontalHolder,
  TabsHorizontalMarker,
  TabsHorizontalUl,
  TabsItemHorizontalButtonOrLink,
  TabsHorizontalItemLi,
} from './TabsHorizontal.styled';

type Props<TValue extends string> = {
  tabs: Tab<TValue>[] | readonly Tab<TValue>[];
  value: TValue | undefined;
  onSelectTab?: (value: TValue) => void;
  compact?: boolean;
};

export function TabsHorizontal<T extends string>({
  tabs,
  value,
  onSelectTab,
  compact,
}: Props<T>) {
  const { tabsHolderRef, markerRef, moveMarker } = useTabsController({
    tabs,
    value,
    onSelectTab,
    hasMarker: true,
  });

  return (
    <TabsHorizontalHolder data-qa-id="tabs">
      <TabsHorizontalUl
        ref={tabsHolderRef}
        data-compact={compact ? true : undefined}
        onScroll={() => moveMarker(false)}
      >
        {tabs.map((tab) => {
          const onClick = () => onSelectTab?.(tab.value);

          return (
            <TabsHorizontalItemLi key={tab.value} data-qa-id="tabs-item">
              <TabsItemHorizontalButtonOrLink
                data={
                  tab.href
                    ? { type: 'link', href: tab.href, onClick }
                    : { type: 'button', onClick }
                }
                id={tab.tabButtonId}
                qaId={tab.qaId}
                aria-selected={tab.value === value}
                aria-controls={tab.href ? undefined : tab.tabPanelId}
                data-compact={compact ? true : undefined}
              >
                {tab.label}
              </TabsItemHorizontalButtonOrLink>
            </TabsHorizontalItemLi>
          );
        })}
      </TabsHorizontalUl>

      <TabsHorizontalMarker ref={markerRef} />
    </TabsHorizontalHolder>
  );
}
